import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { Observable, map } from 'rxjs';

import { FinnairCompletionStatus } from '@fcom/dapi/api/models';
import { ButtonComponent, ButtonSize, ButtonTheme } from '@fcom/ui-components';

import { FinnairPassengerItemWithApis } from '../../../check-in/interface/check-in.interface';

interface PassengengerWithDetails extends FinnairPassengerItemWithApis {
  completed: boolean;
  key?: string;
  information: Array<{ name: string; completed: boolean }>;
}

interface OpenFormEvent {
  passengerId: string;
  triggerElement: ButtonComponent;
}

@Component({
  selector: 'fin-apis-passenger',
  templateUrl: 'apis-passenger.component.html',
  styleUrls: ['./apis-passenger.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ApisPassengerComponent implements OnInit {
  readonly ButtonSize = ButtonSize;
  readonly ButtonTheme = ButtonTheme;
  readonly FinnairCompletionStatus = FinnairCompletionStatus;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input() passenger$: Observable<FinnairPassengerItemWithApis>;
  @Input() requiredTravelRequirements: string[];
  @Input() hideEditButton = false;
  @Output() openForm: EventEmitter<OpenFormEvent> = new EventEmitter<OpenFormEvent>();

  passengerWithDetails$: Observable<PassengengerWithDetails>;
  expandOpen: boolean;

  ngOnInit(): void {
    this.passengerWithDetails$ = this.passenger$.pipe(
      map((passenger) => {
        return {
          ...passenger,
          completed: passenger.advancePassengerInformation.status === FinnairCompletionStatus.COMPLETED,
          information: [
            {
              name: 'passengerInformation',
              completed:
                passenger.advancePassengerInformation.passengerInformation.status === FinnairCompletionStatus.COMPLETED,
            },
            {
              name: 'travelDocument',
              completed:
                passenger.advancePassengerInformation.travelDocument.status === FinnairCompletionStatus.COMPLETED,
            },
            {
              name: 'residencyAddress',
              completed:
                passenger.advancePassengerInformation.residencyAddress.status === FinnairCompletionStatus.COMPLETED,
            },
            {
              name: 'destinationAddress',
              completed:
                passenger.advancePassengerInformation.destinationAddress.status === FinnairCompletionStatus.COMPLETED,
            },
          ].filter((information) => this.requiredTravelRequirements.includes(information.name)),
        };
      })
    );
  }
}
